import axios from 'axios';
// import { env } from 'config/env.js';
// import getRequest from 'utils/getRequest.js';
import { requestInter, responseInter } from './requestInter';
let type = process.env.VUE_APP_ENV;
// let baseUrl = env[type]['ajaxPath'];
let token = localStorage.getItem('token') || '';
let fetch = axios.create({
    // timeout: 10000,
    baseURL:  '/suanfa',
    // baseURL: 'http://10.2.118.33:8010',
    headers: {
        'Authorization':'bearer' +token,
    },
    withCredentials:true,

});
requestInter(fetch);
responseInter(fetch);
export default fetch;